import { render, staticRenderFns } from "./setCash.vue?vue&type=template&id=58968c5e&scoped=true&"
import script from "./setCash.vue?vue&type=script&lang=js&"
export * from "./setCash.vue?vue&type=script&lang=js&"
import style0 from "./setCash.vue?vue&type=style&index=0&id=58968c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58968c5e",
  null
  
)

export default component.exports